
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja-ps/pegawai/perencanaan/rangkuman",
      function () {
        return require("private-next-pages/pengelolaan-kinerja-ps/pegawai/perencanaan/rangkuman.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja-ps/pegawai/perencanaan/rangkuman"])
      });
    }
  